import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4316362"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create_new_lead_wrapper" }
const _hoisted_2 = { class: "create_new_lead_body" }
const _hoisted_3 = { class: "create_new_lead_body_title" }
const _hoisted_4 = { class: "create_new_lead_content_wrapper" }
const _hoisted_5 = { class: "create_new_lead" }
const _hoisted_6 = { class: "two_block_wrapper" }
const _hoisted_7 = { class: "left_block mb-4" }
const _hoisted_8 = { class: "exist_phone_error" }
const _hoisted_9 = { class: "right_block mb-4" }
const _hoisted_10 = { class: "three_block_wrapper" }
const _hoisted_11 = { class: "left_two_blocks" }
const _hoisted_12 = { class: "left_block mb-4" }
const _hoisted_13 = { class: "right_block mb-4" }
const _hoisted_14 = { class: "right_one_block mb-4" }
const _hoisted_15 = { class: "two_block_wrapper" }
const _hoisted_16 = { class: "left_block mb-4" }
const _hoisted_17 = { class: "right_block mb-4" }
const _hoisted_18 = { class: "two_block_wrapper" }
const _hoisted_19 = { class: "left_block mb-4" }
const _hoisted_20 = { class: "right_block mb-4" }
const _hoisted_21 = { class: "position-relative" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: "/assets/img/clock.svg"
}, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "create_new_lead_buttons_wrapper" }
const _hoisted_25 = ["disabled"]

export function render(_ctx, _cache) {
  const _component_v_input = _resolveComponent("v-input")
  const _component_v_select = _resolveComponent("v-select")
  const _component_v_textarea = _resolveComponent("v-textarea")
  const _directive_maska = _resolveDirective("maska")
  const _directive_click_outside = _resolveDirective("click-outside")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('task.create.create_task')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createVNode(_component_v_input, {
                modelValue: _ctx.phone,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.phone) = $event)),
                placeholder: "+7 (000) 000-00-00",
                label: _ctx.$t('clients.view.phone'),
                height: "22",
                error: _ctx.isShowExistError,
                errorText: _ctx.phoneErrorText,
                onBlur: _ctx.checkLeadExist,
                onFocus: _cache[1] || (_cache[1] = $event => {_ctx.phoneErrorText = ''; _ctx.isShowExistError = false}),
                clearable: ""
              }, null, 8, ["modelValue", "label", "error", "errorText", "onBlur"]), [
                [_directive_maska, void 0, _ctx.options]
              ]),
              _withDirectives(_createElementVNode("span", _hoisted_8, [
                _createTextVNode(_toDisplayString(_ctx.$t('task.create.phone_exist_error')) + " ", 1),
                _createElementVNode("a", {
                  onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.clickOnRedirect && _ctx.clickOnRedirect(...args)))
                }, _toDisplayString(_ctx.$t('task.create.go_over')), 1)
              ], 512), [
                [_vShow, _ctx.isShowExistError]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_v_select, {
                class: "w-100",
                modelValue: _ctx.selectedClub,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = $event => ((_ctx.selectedClub) = $event)),
                  _ctx.checkLeadExist
                ],
                label: 'task.create.club',
                items: _ctx.clubs,
                errorText: _ctx.clubErrorText,
                onClick: _cache[4] || (_cache[4] = $event => (_ctx.clubErrorText = ''))
              }, null, 8, ["modelValue", "label", "onUpdate:modelValue", "items", "errorText"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_v_input, {
                  modelValue: _ctx.name,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.name) = $event)),
                  label: _ctx.$t('task.create.name'),
                  height: "22",
                  errorText: _ctx.nameErrorText,
                  onFocus: _cache[6] || (_cache[6] = $event => (_ctx.nameErrorText = '')),
                  clearable: ""
                }, null, 8, ["modelValue", "label", "errorText"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_v_select, {
                  class: "w-100",
                  modelValue: _ctx.selectedSex,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.selectedSex) = $event)),
                  label: 'task.create.sex',
                  items: _ctx.sex
                }, null, 8, ["modelValue", "label", "items"])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_v_input, {
                modelValue: _ctx.mail,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.mail) = $event)),
                label: _ctx.$t('task.create.mail'),
                height: "22",
                clearable: ""
              }, null, 8, ["modelValue", "label"])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_v_select, {
                class: "w-100",
                modelValue: _ctx.selectedStatus,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.selectedStatus) = $event)),
                label: 'task.create.status',
                items: _ctx.statuses,
                clearable: ""
              }, null, 8, ["modelValue", "label", "items"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_v_select, {
                class: "w-100",
                modelValue: _ctx.selectedManagers,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.selectedManagers) = $event)),
                label: 'task.create.manager',
                items: _ctx.managers,
                clearable: ""
              }, null, 8, ["modelValue", "label", "items"])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_v_select, {
                class: "w-100",
                modelValue: _ctx.selectedNextStep,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.selectedNextStep) = $event)),
                label: 'task.create.next_step',
                items: _ctx.nextSteps,
                clearable: ""
              }, null, 8, ["modelValue", "label", "items"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_v_input, {
                  modelValue: _ctx.date,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.date) = $event)),
                  label: _ctx.$t('task.create.date'),
                  inputType: 'datetime-local',
                  height: "22",
                  errorText: _ctx.dateErrorText,
                  onFocus: _cache[13] || (_cache[13] = $event => (_ctx.dateErrorText = '')),
                  clearable: ""
                }, null, 8, ["modelValue", "label", "errorText"]),
                _createElementVNode("button", {
                  class: "now_button",
                  onClick: _cache[14] || (_cache[14] = (...args) => (_ctx.setNowTime && _ctx.setNowTime(...args)))
                }, _hoisted_23)
              ])
            ])
          ]),
          _createVNode(_component_v_textarea, {
            modelValue: _ctx.message,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => ((_ctx.message) = $event)),
            label: _ctx.$t('task.create.comment')
          }, null, 8, ["modelValue", "label"])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("button", {
            class: "primary_button",
            onClick: _cache[16] || (_cache[16] = (...args) => (_ctx.save && _ctx.save(...args))),
            disabled: _ctx.isButtonDisabled
          }, _toDisplayString(_ctx.$t('task.create.create')), 9, _hoisted_25),
          _createElementVNode("button", {
            class: "secondary_button button_space",
            onClick: _cache[17] || (_cache[17] = $event => (_ctx.$emit('close')))
          }, _toDisplayString(_ctx.$t('task.create.cancel')), 1)
        ])
      ])
    ])), [
      [_directive_click_outside, _ctx.close]
    ])
  ]))
}